import Vue from 'vue';
export const GlobalEvent = new Vue();